import React from 'react'

const Loader = () => {
  return (
    <div className="wifi-loader-container">
           <div class="loading">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
    </div>
  )
}

export default Loader